import {Style, Fill, Stroke, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class SigmetLayer extends GeoJsonLayer {

    hazards = ["trop", "conv", "turb", "icing", "ifr", "va" ];

    constructor( map, settings = {}){
        settings["name"] = 'sigmet';
        settings["dynamic_time"] = true;
        settings["dynamic_level"] = true;
        settings["api_endpt"] = "SigmetJSON.php";
        if( settings.opacity == undefined ) settings['opacity'] = .5;
        if( settings.hazards == undefined ) settings['hazards'] = "all";
        if( settings.heights == undefined ) settings['heights'] = false;
        if( settings.series == undefined ) settings['series'] = false;
        if( settings.bottom == undefined ) settings['bottom'] = undefined;
        if( settings.top == undefined ) settings['top'] = undefined;
        super( map, settings );
        // Setup checkbox on UI
        this,this.setHazards(this.settings['hazards'], false);
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "hazard", this.settings['hazards']);
        if( this.map.level != undefined ) url.searchParams.set( "level", this.map.level );
        if( this.settings['bottom'] != undefined ) url.searchParams.set( "bottom", this.settings['bottom'] );
        if( this.settings['top'] != undefined ) url.searchParams.set( "top", this.settings['top'] );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    getColor( feature ){
        if( this.property(feature,'sigmet_type') == "OUTLOOK" )
            return "#FFAA00";
        if( this.property(feature,'hazard') == "TS" )
            return "#800000";
        if( this.property(feature,'hazard') == "TC" )
            return "#800000";
        if( this.property(feature,'hazard') == "ICE" )
            return "#000080";
        if( this.property(feature,'hazard') == "TURB" )
            return "#A06000";
        if( this.property(feature,'hazard') == "VA" )
            return "#808080";
        return "#800000";
    }

    getHighlightColor(feature){
        if( this.property(feature,'sigmet_type') == "OUTLOOK" )
            return "#FFCC88";
        if( this.property(feature,'hazard') == "ICE" )
            return "#8080FF";
        if( this.property(feature,'hazard') == "TURB" )
            return "#FFA000";
        if( this.property(feature,'hazard') == "VA" )
            return "#FFFFFF";
        if( this.property(feature,'hazard') == "IFR" )
            return "#FF80FF";
        return "#FF8080";
    }

    getLineColor(feature){
        if( this.property(feature,'sigmet_type') == "OUTLOOK" )
            return "#FFAA00";
        return "#800000";
    }

    getLabel( feature ){
        let label = "";
        // 'MTN OBSCN','IFR','TURB','ICE','CONVECTIVE','ASH'
        if( this.property(feature,'hazard') == "CONV" )
            label += "Conv";
        else if( this.property(feature,'hazard') == "TURB" )
            label += "Turb";
        else if( this.property(feature,'hazard') == "ICE" )
            label += "Icing";
        else if( this.property(feature,'hazard') == "VA" )
            label += "VA";
        else if( this.property(feature,'hazard') == "DS" )
            label += "Dust";
        else
            label = label + this.property(feature,'hazard')
        if( this.settings['heights'] ){
            if( this.property(feature,'base') != undefined &&
                    this.property(feature,'top') != undefined )
                label += " " + Math.round(this.property(feature,'base')/100) + "-" +
                    Math.round(this.property(feature,'top')/100);
            else if( this.property(feature,'top') != undefined )
                label += " -" + Math.round(this.property(feature,'top')/100);
        }
        if( this.settings['series'] ){
            label += " " + this.property(feature,'series_id');
        }
        return label;
    }

    getOpacity(feature){
        return this.settings['opacity'];
    }

    getStyle(feature, resolution ){
        let style = new Style({
                "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getColor(feature), this.settings['opacity'])
                        }),
                "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getLineColor(feature)),
                        "width": 2
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray("#800000")
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 })
                        })

                });
        return style;
    }

    getSelectedStyle(feature, resolution ){
        console.info( "ss-s" );
        let style = new Style({
                "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getHighlightColor(feature), this.settings['opacity'])
                        }),
                "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getLineColor(feature)),
                        "width": 2
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray("#800000")
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 })
                        })

                });
        return style;
    }

    getPopupText( feature ){
        let rawtext = this.property(feature,'raw_sigmet');
        rawtext = rawtext.replace(/\n/g, "<br/>");
        let type = "SIGMET";
        if( this.property(feature,'sigmet_type') == "OUTLOOK" ) type = "OUTLOOK";
        let text = this.popupTitle( type, this.property(feature,'hazard'));
        text += this.popupData( "Series Id", this.property(feature,'sigmet_type') + " " + this.property(feature,'series_id'));
        text += this.popupData( "FIR Id", this.property(feature,'fir_id'));
        text += this.popupData( "Begins", this.property(feature,'valid_time_from'));
        text += this.popupData( "Ends", this.property(feature,'valid_time_to'));
        if( this.property(feature,'top') != undefined )
            text += this.popupData( "Top", this.property(feature,'top') + " ft" );
        if( this.property(feature,'base') != undefined )
            text += this.popupData( "Base", this.property(feature,'base') + " ft" );
        if( this.property(feature,'dir') != undefined ){
            if( this.property(feature,'spd') == "UNK" )
                text += this.popupData( "Movement", "unknown" );
            else if( this.property(feature,'spd') == 0 )
                text += this.popupData( "Movement", "stationary" );
            else
                text += this.popupData( "Movement", this.property(feature,'dir') + " deg at " + this.property(feature,'spd') + " kt" );
        }
        if( this.property(feature,'chng') != undefined )
            text += this.popupData( "Change", this.property(feature,'chng') );
        if( this.property(feature,'geom') == "UNK" )
            text += this.popupData( "Region", "Undetermined, displaying whole FIR" );
        text += this.popupSep();
        text += this.popupData( "", rawtext );
        text += this.popupEnd();
        return text;
    }

    setHazards(val, refresh = true){
        if( val == undefined ){
            let params = [];
            for( let i = 0; i < this.hazards.length; i++ ){
                if( Library.getCheckbox( "check_sigmet_hazards_"+this.hazards[i] )){
                    params.push( this.hazards[i]);
                }
            }
            this.settings['hazards'] = params.join(",");
        } else {
            let params = val.split(",");
            if( params[0] == "all" ){
                for( let i = 0; i < this.hazards.length; i++ )
                    Library.setCheckbox( "check_sigmet_hazards_"+this.hazards[i], true );
            } else {
                for( let i = 0; i < this.hazards.length; i++ )
                    Library.setCheckbox( "check_sigmet_hazards_"+this.hazards[i], false );
            }
            for( let i = 0; i < params.length; i++ )
                Library.setCheckbox( "check_sigmet_hazards_"+params[i], true );

            this.settings['hazards'] = val;
        }
        if( refresh ){
            this.refresh();
        }
    }

    setOpacity( val ){
        this.settings['opacity'] = Number(val);
        this.refresh();
        return 1;
    }

    updateLevel(){
        this.refresh();
    }
    
    updateTime(){
        this.refresh();
    }
}
